interface StreamsHeroProps {
  onGoLiveClick: () => void;
  onUploadClick: () => void;
  onMonetizationClick: () => void;
}

export default function StreamsHero({ onGoLiveClick, onUploadClick, onMonetizationClick }: StreamsHeroProps) {
  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-purple-900/30 to-gray-900">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-10"></div>
        </div>
      </div>
      
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/395c7569ee839c55894731ae4d6b1ee8.jpg"
          alt="Streams"
          className="w-full h-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-purple-900/40 to-black/60"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl mx-auto">
        <div className="inline-flex items-center bg-red-600/20 border border-red-500/50 rounded-full px-4 sm:px-5 py-2 mb-6 backdrop-blur-sm">
          <span className="w-2 h-2 bg-red-500 rounded-full mr-2 animate-pulse"></span>
          <span className="text-red-400 font-semibold text-xs sm:text-sm">LIVE STREAMING PLATFORM</span>
        </div>
        
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Stream Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Gameplay</span>
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed">
          Go live instantly, upload your best matches, or schedule streams in advance. Connect with your audience in real-time with interactive features.
        </p>
        
        <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center">
          <button 
            onClick={onGoLiveClick}
            className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold transition-all transform hover:scale-105 shadow-lg shadow-red-500/50 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-live-line mr-2"></i>
            Go Live
          </button>
          <button 
            onClick={onUploadClick}
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold transition-all transform hover:scale-105 shadow-lg shadow-purple-500/50 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-upload-2-line mr-2"></i>
            Upload Video
          </button>
          <button 
            onClick={onMonetizationClick}
            className="bg-gray-800/80 backdrop-blur-sm border-2 border-purple-500/50 text-purple-300 hover:bg-purple-600 hover:text-white hover:border-purple-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-money-dollar-circle-line mr-2"></i>
            Monetization
          </button>
        </div>
      </div>
    </section>
  );
}
